import { normalizeAssetMap } from '@x1/ui-web/lib/assets';

export const IMAGES = normalizeAssetMap({
  creditCardLogo: 'https://robinhood.com/creditcard/static/email/narrow-logo.png',
  loungeKeyLogo: 'https://x1creditcard.com/static/x1-app/pass/LoungeKeyLogo.png',
  downloadAppSplash: 'https://robinhood.com/creditcard/static/web/DownloadAppSplash.png',
});
